import { useCallback } from 'react';
import { useEscapeKey } from './useEscapeKey';
import { type Column, type GridApi } from 'ag-grid-community';
/**
 * Hook that handles Escape key presses for Grid.tsx.
 *
 * Hides popup menus and prevents propagation to parent modal handlers (Modal.js and AuthoringWorkflow.tsx).
 *
 * @param gridApi - The ag-Grid API instance
 * @param gridRefWrapper - React ref to the grid container element
 * @param columnMenuColumnRef - React ref to the column whose menu is currently open
 * @param showAgGridColumnMenu - Whether the column menu is currently visible
 */
export function useGridEscapeKeyHandler(
  gridApi: GridApi | null,
  gridRefWrapper: React.RefObject<HTMLDivElement>,
  columnMenuColumnRef: React.RefObject<Column | null>,
  showAgGridColumnMenu?: boolean,
) {
  const onKeyup = useCallback(() => {
    gridApi?.hidePopupMenu();
    const column = columnMenuColumnRef.current;
    if (column) {
      gridApi?.setFocusedHeader(column);
    }
  }, [gridApi, columnMenuColumnRef]);
  useEscapeKey({
    onKeyup: onKeyup,
    enabled: Boolean(gridApi) && showAgGridColumnMenu,
    eventTarget: gridRefWrapper.current ?? window,
    restoreFocusTarget: '.authoring-modal',
  });
}
